import { useState, type ReactNode } from 'react';

import { DayMode } from '../../domain/routine/enums';
import { DayModeAtmosphereContext } from './dayModeAtmosphereContext';

export function DayModeAtmosphereProvider({ children }: { readonly children: ReactNode }) {
  const [dayMode, setDayMode] = useState<DayMode>(DayMode.normal);
  return (
    <DayModeAtmosphereContext.Provider value={{ dayMode, setDayMode }}>
      {children}
    </DayModeAtmosphereContext.Provider>
  );
}
